import React from 'react';

import Filterable from '@components/Filterable/Filterable';
import BannersList from './BannersList';
import { bannersSet } from './constants/bannersSet';
import { FILTERS } from './constants';

const Banners = () => (
  <Filterable
    customClasses={'main-content'}
    filters={FILTERS}
    data={bannersSet}
    withoutSearch
  >
    <BannersList />
  </Filterable>
);

Headers.displayName = 'BannersPage';

export default Banners;



// WEBPACK FOOTER //
// ./src/containers/components/Banner/Banners.js